import React, { useState } from "react";
import { usePagination } from "../../../hooks/usePagination";
import ResultHandler from "../../../components/ResultHandler";
import PaginationHandler from "../../../components/PaginationHandler";
import TableHeaderHandler from "../../../components/TableHeaderHandler";
import { useTranslation } from "react-i18next";
import TableAction from "../../../components/TableAction";
import EmptyData from "../../../components/EmptyData";
import { Table, Thead, Tbody, Td, Tr, Th } from "react-super-responsive-table";
import "react-super-responsive-table/dist/SuperResponsiveTableStyle.css";
import { PERMISSIONS } from "../../../api/permissions";
import { useHistory } from "react-router-dom";
import { useResponse } from "../../../hooks/useResponse";
import DeleteModal from "../../../components/Common/DeleteModal";
import { Badge, Button, Col, Label, Row } from "reactstrap";
import { deleteHousing, getHousings } from "../../../api/housing";
import { ZoomImage } from "../../../components/zoom-image/ZoomImage";
import TableFilter from "../../../components/TableFilter";
import HousingTimeline from "./HousingTimeline";
                        
export default function HousingTable() {
  const { t } = useTranslation();
  const navigate = useHistory();

  const {
    response,
    loading,
    error,
    setPage,
    page,
    setPerPage,
    totalPages,
    setPayload,
    setMeta,
  } = usePagination(getHousings);

  // Filter
  const filterTypes = [
    { key: "street_name", type: "text" },
    { key: "city", type: "text" },
    { key: "rooms_number", type: "number" },
  ];

  // delete
  const [show, setShow] = useState(false);
  const [deletingHouse, setDeletingHouse] = useState(null);

  const { setData } = useResponse(deleteHousing, () => {
    setShow(false);
    setDeletingHouse(null);
    setPayload({ ref: true });
  });

  function onDeleteClick() {
    setData({ type: "delete", data: deletingHouse });
  }

  function onCloseClick() {
    setShow(false);
  }

  return (
    <>    
      <HousingTimeline />
    
      <TableHeaderHandler
        permission={PERMISSIONS.HOUSING_CREATE}
        addUrl="/add-housing"
        setPage={setPage}
        setPerPage={setPerPage}
      ></TableHeaderHandler>
      
      <TableFilter
        filterTypes={filterTypes}
        onFilter={(filters) => setMeta({ page: 1, payload: filters })}
      />

      <div className="table-rep-plugin">
        <div className="table-responsive">
          <Table className="table table-striped table-bordered">
            <Thead className="table-light table-nowrap">
              <Tr>
                <Th>Street Name</Th>
                <Th>Number</Th>
                <Th>City</Th>
                <Th>Active</Th>
                <Th>Max People</Th>
                <Th>Picture</Th>
                <Th>Rooms Number</Th>
                <Th>Rooms</Th>
                <Th>Renters</Th>
                <Th className="d-flex">{t("tables.Action")}</Th>
              </Tr>
            </Thead>

            {response.data && !loading && (
              <Tbody>
                {response.data.housings.map((row) => {
                  return (
                    <Tr key={row.id}>
                      <Td>{row.street_name}</Td>
                      <Td>{row.number}</Td>
                      <Td>{row.city}</Td>
                        <Td>
                          <Badge style={{fontSize: "12px"}} color={row.isActive ? 'success': 'danger'}>
                            {row.isActive ? 'YES' : 'NO'}
                          </Badge>
                        </Td>
                      <Td>{row.max_capacity}</Td>
                      <Td>
                        {row.picture && (
                          <ZoomImage
                            src={row.picture}
                            alt="room image"
                            width={150}
                          />
                        )}
                      </Td>
                      <Td>{row.rooms_number}</Td>
                      <Td>
                        <Button color="dark" size="sm" onClick={() => navigate.push(`/rooms/${row.id}`)}>
                          Rooms
                        </Button>
                      </Td>
                      <Td>
                        <Button color="dark" size="sm" onClick={() => navigate.push(`/housing-renters/${row.id}`)}>
                          Renters
                        </Button>
                      </Td>
                      <Td className="d-flex">
                        <TableAction
                          hasEdit={true}
                          editPermission={PERMISSIONS.HOUSING_EDIT}
                          hasDelete={true}
                          deletePermission={PERMISSIONS.HOUSING_DELETE}
                          type="housing"
                          id={row.id}
                          setShow={setShow}
                          setDeleteIntitiy={setDeletingHouse}
                        />
                        <Button
                          style={{ marginLeft: "5px" }}
                          color="dark"
                          onClick={() => navigate.push("/housing/" + row.id)}
                        >
                          <i className="bx bxs-show font-size-16 align-middle" />
                        </Button>
                      </Td>
                    </Tr>
                  );
                })}
              </Tbody>
            )}
          </Table>

          {!loading && (
            <EmptyData
              empty={response.data && response.data.housings.length === 0}
              msg="No Housing Found."
            />
          )}

          <DeleteModal
            show={show}
            onDeleteClick={onDeleteClick}
            onCloseClick={onCloseClick}
          />

          {response.data && !loading && (
            <PaginationHandler
              page={page}
              setPage={setPage}
              totalPages={totalPages}
            />
          )}

          <ResultHandler error={error} loading={loading} />
        </div>
      </div>
    </>
  );
}
